import clsx from 'clsx'
import {getColorForString} from 'common/helpers'
import {FC} from 'react'

import {toAbsoluteUrl} from '_metronic/helpers'

type Size =
  | '20'
  | '25'
  | '30'
  | '35'
  | '40'
  | '45'
  | '50'
  | '55'
  | '60'
  | '65'
  | '70'
  | '75'
  | '100'
  | '125'
  | '150'
  | '160'
  | '175'
  | '200'

export type AvatarProps = {
  src?: string
  alt?: string
  className?: string
  label?: string
  circle?: boolean
  size?: Size
  smSize?: Size
  mdSize?: Size
  lgSize?: Size
  xlSize?: Size
  xxlSize?: Size
  color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info'
  colorHashKey?: string
  showLabel?: boolean
}

const Avatar: FC<AvatarProps> = ({
  src,
  alt = 'avatar',
  className,
  label,
  size = '50',
  smSize,
  mdSize,
  lgSize,
  xlSize,
  xxlSize,
  circle = false,
  color,
  colorHashKey,
  showLabel = false,
}) => {
  const defaultImage = toAbsoluteUrl('/media/avatars/blank.png')
  const imageSrc = src || defaultImage

  const initials =
    label
      ?.split(' ')
      .map((name) => name.charAt(0))
      .join('')
      .toUpperCase() || 'N/A'

  let computedColor = color
  if (!computedColor) {
    let computedHash = colorHashKey
    if (!computedHash) {
      computedHash = label
    }
    if (!computedHash) {
      computedHash = src
    }
    if (!computedHash) {
      computedHash = alt
    }
    if (!computedHash) {
      computedHash = 'default'
    }
    computedColor = getColorForString(computedHash)
  }

  return (
    <div
      className={clsx('symbol', className, {
        [`symbol-${size}px`]: !!size,
        [`symbol-sm-${smSize}px`]: !!smSize,
        [`symbol-md-${mdSize}px`]: !!mdSize,
        [`symbol-lg-${lgSize}px`]: !!lgSize,
        [`symbol-xl-${xlSize}px`]: !!xlSize,
        [`symbol-xxl-${xxlSize}px`]: !!xxlSize,
        'symbol-circle': circle,
      })}
    >
      {!showLabel && <img src={imageSrc} alt={alt} style={{objectFit: 'cover'}} />}
      {showLabel && initials && (
        <span
          className={clsx(
            'symbol-label fs-6 fw-bolder',
            `bg-light-${computedColor}`,
            `text-${computedColor}`
          )}
        >
          {initials}
        </span>
      )}
    </div>
  )
}

export default Avatar
